/** Published X25519 public keys for envelope wrap. Secrets stay off-repo. */

export const REVIEWER_PUBLIC_KEYS = [
  {
    kid: 'admin-b1a0',
    address: '0xb1a02681026cFEeFAD337368D2b546C72fcEb068',
    publicHex: '0x50bda242998bcf588ac19264c2d12c111ffd2b218b40475d90588a408aea6b54',
  },
  {
    kid: 'admin-35df',
    address: '0x35DF663AecA44d466AE11aeE42fFb4ec5f96C6cc',
    publicHex: '0x8a87da04c19c082c0a01e20dc7a2d3a93728cd3d07938c1e7daca270f5c7147b',
  },
] as const;
